import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { toBase64 } from "../../Services/commonHelper";
import { createProductGallery, createProductInstruction } from "../../Services/ProductService";

const AddProductGallery = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        id: "",
        name: "",
        image: "",
        alias: "",
        media_type: "",
    });
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const [previewImage, setPreviewImage] = useState({
        icon: ""
    });
    const uploadLogoRef = useRef(null);

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const redirect = (url) => {
        navigate(url, { state: reqData })
    };

    const handleImport = async (e, field) => {
        const file = e.target.files[0];
        e.target.value = "";
        if (file?.type?.includes("image/jpeg") || file?.type?.includes("image/png")) {
            let base64String = await toBase64(file);
            handleChange(field, base64String);
            setPreviewImage({ ...previewImage, [field]: URL?.createObjectURL(file) });
        } else {
            toast.error("Image must ba valid .jpeg file")
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await createProductGallery({ ...reqData, product_id: data?.data?.product_id });
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    useEffect(() => {
        if (data?.data?.id) {
            const { id, name, image, alias, media_type } = data?.data;
            setReqData({ id, name, image, alias, media_type });
        }else{
            setReqData({...reqData, media_type: "video"})
        }
    }, []);

    return (
        <div
            className="modal modal-fullscreen custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add Gallery" : "Edit Gallery"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Name"
                                                required
                                                value={reqData?.name}
                                                onChange={(e) => handleChange("name", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Alias</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Alias"
                                                required
                                                value={reqData?.alias}
                                                onChange={(e) => handleChange("alias", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Media Type</label>
                                            <select required value={reqData?.media_type} onChange={(e) => handleChange("media_type", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value="">Media Type</option>
                                                <option selected value={"video"}>Video</option>
                                                <option value={"image"}>Image</option>
                                            </select>
                                        </div>
                                        {reqData?.media_type == "video" ?
                                            <div className="form-group">
                                                <label>Video URL</label>
                                                <input
                                                    type="url"
                                                    className="form-control"
                                                    placeholder="Video URL"
                                                    required
                                                    value={reqData?.image}
                                                    onChange={(e) => handleChange("image", e?.target?.value)}
                                                />
                                            </div>
                                            :
                                            <div className="d-flex bank-details-btn" style={{ marginTop: "40px" }}>
                                                <div>
                                                    <button onClick={(e) => { e.preventDefault(); uploadLogoRef?.current?.click() }} className={`btn bank-save-btn`}>
                                                        {reqData?.image ? "Change" : "Add Image"}
                                                    </button>
                                                </div>
                                                {Boolean(previewImage?.image || reqData?.image) && <img
                                                    width={75}
                                                    class="mx-3 img-thumbnail"
                                                    alt="Icon Image"
                                                    src={previewImage?.image ? previewImage?.image : reqData?.image}
                                                />}
                                            </div>}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className="bank-details-btn">
                                    <button
                                        data-bs-dismiss="modal"
                                        className="btn bank-cancel-btn me-2"
                                        onClick={() => onClose()}
                                        disabled={loader}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn bank-save-btn me-2"
                                        disabled={loader}
                                    >
                                        {loader ? "Loading..." : "Save"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <input hidden ref={uploadLogoRef} type="file" name="upload" id="upload" onChange={(e) => handleImport(e, "image")} />
        </div>
    );
};

export default AddProductGallery;